enum TokenSaveType{
    Cookies =0 ,
    LocalStore = 1
}

export default TokenSaveType;